export default {"src":"/_next/static/media/turnover.e0d95ba9.svg","height":25,"width":25};